/** Share a bounded comparison context across list, detail and breadcrumb links. */
export function savedOfferIds(params: URLSearchParams): string[] {
  return [...new Set(params.getAll("angebot").filter(Boolean))].slice(0, 3);
}

export function savedOfferUrl(ids: string[], compare = false, returnTo?: string): string {
  const params = new URLSearchParams();
  [...new Set(ids)].slice(0, 3).forEach(id => params.append("angebot", id));
  if (returnTo && (isOfferListUrl(returnTo) || isBelegeOfferUrl(returnTo))) params.set("return_to", returnTo);
  // Ausgewählt wird im Preisspiegel (#630).
  return `${compare ? "/angebote/vergleichen" : "/preisspiegel"}${params.size ? `?${params}` : ""}`;
}

export function savedOfferDetailUrl(id: string, selected: string[], returnTo?: string): string {
  const search = savedOfferUrl(selected, false, returnTo).split("?")[1];
  // Opaque ids in older links need the route to supply their document kind.
  const detailPath = id.startsWith("angebot:") ? "/belege" : "/angebote";
  return `${detailPath}/${encodeURIComponent(id)}${search ? `?${search}` : ""}`;
}

const isOfferListUrl = (target: string) => ["/angebote", "/preisspiegel"].some(path => target === path || target.startsWith(`${path}?`));
const isBelegeOfferUrl = (target: string) => target.startsWith("/belege?")
  && new URLSearchParams(target.split("?")[1]).get("type") === "angebot";

/** Only the two offer lists are valid return destinations; never follow arbitrary URLs. */
export function savedOfferReturnUrl(selected: string[], params: URLSearchParams): string {
  const target = params.get("return_to");
  if (target && isBelegeOfferUrl(target)) {
    const source = new URLSearchParams(target.split("?")[1]);
    const result = new URLSearchParams({ type: "angebot", status: "all" });
    for (const key of ["q", "supplier", "period", "from", "to", "sort", "status"]) {
      if (source.has(key)) result.set(key, source.get(key)!);
    }
    selected.forEach(id => result.append("angebot", id));
    return `/belege?${result}`;
  }
  if (!target || !isOfferListUrl(target)) return savedOfferUrl(selected);
  const source = new URLSearchParams(target.split("?")[1] ?? "");
  const result = new URLSearchParams();
  for (const key of ["q", "sort"]) if (source.has(key)) result.set(key, source.get(key)!);
  result.set("view", "default");
  selected.forEach(id => result.append("angebot", id));
  return `/preisspiegel?${result}`;
}
